class Tolerances {
    constructor() {
        this.thickness = 0.01;
        this.volume = 0.0001;
    }
}
export const tolerances = new Tolerances();
